import { render, staticRenderFns } from "./personalRequests.vue?vue&type=template&id=560e661a&scoped=true"
import script from "./personalRequests.vue?vue&type=script&lang=js"
export * from "./personalRequests.vue?vue&type=script&lang=js"
import style0 from "./personalRequests.vue?vue&type=style&index=0&id=560e661a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560e661a",
  null
  
)

export default component.exports